<template>
  <div>
    <div class="products">
      <ProductTitle></ProductTitle>
      <div class="box gray-box">
        <div style="border: none;" class="empty-container box-body">
          <h3>您的购物车是空的</h3>
          <p>&nbsp;</p>
          <AddProducts>
            <el-button class="btn-320 mobile-button" type="info">去添加</el-button>
          </AddProducts>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddProducts from './AddProducts'
import ProductTitle from './ProductTitle'

export default {
  name: 'ProductList',
  components: {
    AddProducts: AddProducts,
    ProductTitle: ProductTitle
  },
  data () {
    return {
      dialogFormVisible: false,
      form: {
        region: '',
        value: ''
      },
      options: [{
        value: 1,
        label: 1
      }]
    }
  },
  methods: {
    addProduct: function () {
      this.dialogFormVisible = true
    },
    addSuccess () {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.products {
  & > h3 {
    line-height: 25px;
  }

  & > p {
    line-height: 18px;
    margin-bottom: 10px;
    color: #666666;
  }
}
.empty-container {
  text-align: center;
  padding: 50px 0;

  h3 {
    font-size:18px;
    color: #333333;
  }

  p {
    margin: 13px 0 18px;
    font-size:13px;
    color: #666666;
    line-height: 18px;
  }
}
@media screen and (max-width:760px){
  .mobile-button {
    width: 267px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/product/EmptyProduct.vue